exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._1kUWAOfIKzwutinCTVnHXv{background-color:#fff;border-top:1px solid #eee;border-bottom:1px solid #ccc;height:20px;background-position:0 100%;background-repeat:repeat-x}", ""]);

// exports
exports.locals = {
	"rulerHorizontal": "_1kUWAOfIKzwutinCTVnHXv"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules!./~/less-loader!./src/components/Ruler/styles.less
// module id = 114
// module chunks = 0